<div class="step-shell">
  <div class="step-header step-header--intro">
    <h2>{{ 'profile.taxDocumentation' | translate }}</h2>
    <p class="step-copy">{{ 'profile.wereRequiredCollectTaxInformation' | translate }}</p>
  </div>

  <div class="residency-card-list">
    <button
      type="button"
      class="residency-card"
      [class.residency-card--selected]="isResidencySelected('us')"
      (click)="onSelectResidency('us')"
    >
      <div class="residency-card__header">
        <div class="residency-card__title-wrap">
          <span class="residency-radio" [class.residency-radio--selected]="isResidencySelected('us')"></span>
          <span class="residency-card__title">{{ 'profile.taxResidencyUsResidents' | translate }}</span>
        </div>

        <button type="button" class="learn-more-button" (click)="onToggleResidencyInfo('us', $event)">
          <span>{{ 'common.learnMore' | translate }}</span>
          <span
            class="learn-more-button__caret"
            [class.learn-more-button__caret--expanded]="isResidencyInfoExpanded('us')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L8 9.29289L11.6464 5.64645C11.8417 5.45118 12.1583 5.45118 12.3536 5.64645C12.5488 5.84171 12.5488 6.15829 12.3536 6.35355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L3.64645 6.35355C3.45118 6.15829 3.45118 5.84171 3.64645 5.64645Z"
                fill="currentColor"
              />
            </svg>
          </span>
        </button>
      </div>

      @if (isResidencyInfoExpanded('us')) {
        <p class="residency-card__body">{{ 'profile.taxResidencyUsDescription' | translate }}</p>
      }
    </button>

    <button
      type="button"
      class="residency-card"
      [class.residency-card--selected]="isResidencySelected('non_us')"
      (click)="onSelectResidency('non_us')"
    >
      <div class="residency-card__header">
        <div class="residency-card__title-wrap">
          <span class="residency-radio" [class.residency-radio--selected]="isResidencySelected('non_us')"></span>
          <span class="residency-card__title">{{ 'profile.taxResidencyNonUsResidents' | translate }}</span>
        </div>

        <button type="button" class="learn-more-button" (click)="onToggleResidencyInfo('non_us', $event)">
          <span>{{ 'common.learnMore' | translate }}</span>
          <span
            class="learn-more-button__caret"
            [class.learn-more-button__caret--expanded]="isResidencyInfoExpanded('non_us')"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path
                d="M3.64645 5.64645C3.84171 5.45118 4.15829 5.45118 4.35355 5.64645L8 9.29289L11.6464 5.64645C11.8417 5.45118 12.1583 5.45118 12.3536 5.64645C12.5488 5.84171 12.5488 6.15829 12.3536 6.35355L8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L3.64645 6.35355C3.45118 6.15829 3.45118 5.84171 3.64645 5.64645Z"
                fill="currentColor"
              />
            </svg>
          </span>
        </button>
      </div>

      @if (isResidencyInfoExpanded('non_us')) {
        <p class="residency-card__body">{{ 'profile.taxResidencyNonUsDescription' | translate }}</p>
      }
    </button>
  </div>

  <p class="email-copy">
    {{ 'profile.ifYouHave' | translate }}
    <span>info&#64;unigana.com</span>
  </p>
</div>
